import api from '../../api/user/_user'


const state = () => ({
    users: [],

})

// getters
const getters = {

    users: (state) => {
        return state.users
    }
}

// actions
const actions = {

    /**
     * Recuperer tout les utilisateurs
     * 
     */
    async getUsers({commit}) {
        return api.users().then(
            response => {

                commit('SET_USERS', response)
                
                return true
            }
        )
    },

}

// mutations
const mutations = {
    
    SET_USERS(state,users) {
        state.users = users
    }

}

export default {
  state,
  getters,
  actions,
  mutations
}
